export const IDENTITY_INVITE_SET_PASSWORD = `
    mutation M($link_code: String!, $password: String!, $token_from_link: String!) {
        link_user_invite(name: $link_code, password: $password, token: $token_from_link) {
            success
            error_code
            action
        }
    }
`;
